import { createReducer } from '@reduxjs/toolkit'

import actionTypes from './actionTypes'

const initialState = {
  features: [],
}

const featureAccessReducer = createReducer(initialState, builder => {
  builder
    // Replace the full list of feature access entries
    .addCase(actionTypes.SET_FEATURE_LIST, (state, action) => {
      // Expecting an array of { featureCode, isEnabled }
      state.features = action.payload || []
    })
    // Insert or update a single feature entry
    .addCase(actionTypes.UPSERT_FEATURE, (state, action) => {
      const { featureCode, isEnabled } = action.payload

      // Find existing entry index (if any)
      const existingIndex = state.features.findIndex(
        feature => feature.featureCode === featureCode
      )

      if (existingIndex === -1) {
        // If not found, push a new entry
        state.features.push({ featureCode, isEnabled })
      } else {
        // If found, only update the isEnabled flag
        state.features[existingIndex].isEnabled = isEnabled
      }
    })
    .addDefaultCase(state => state)
})

export default featureAccessReducer
